import React, {Component} from 'react';
import {
    Navbar,
    Nav,
    NavbarToggler,
    UncontrolledCollapse
} from 'reactstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {ROLES, SUB_ROLES, NO_SUB_ROLES, SUB_ROLES_TRANSLATIONS} from '../../reducers/account/role';
import {sharedLabelsPath} from "../../reducers/common/localization";
import './NavBarWithRoles.css';
import ConsentRequestsFilter from './../organizationConsentManagement/consentRequestsFilter/ConsentRequestsFilter.container';
import Select, {components} from 'react-select';
import { CURRENCIES } from '../../constants/constants';

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        ":hover": {
            backgroundColor: state.isSelected ? '#89aa11' : 'rgba(137, 170, 17, 0.44)'
        },
        backgroundColor: state.isSelected ? '#89aa11' : 'white',
        cursor: 'pointer',
        width: '140px',
        fontSize: '.9rem',
        paddingTop: '0',
        paddingBottom: '0',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    }),
    control: (provided, state) => ({
        ...provided,
        fontSize: '.875rem',
        cursor: 'pointer',
        width: '140px',
        minHeight: 'calc(1.5em + .5rem + 2px)',
        height: 'calc(1.5em + .5rem + 2px)',
        border: '1px solid #ced4da',
        ":hover": {
            border: '1px solid #ced4da',
        },
        borderColor: state.isFocused ? '#80bdff' : '#ced4da',
        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: '0 5px 0 0'
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    menu: styles => ({
        ...styles,
        marginTop: '0',
        marginBottom: '0',
        borderRadius: '0'
    }),
    menuList: styles => ({
        ...styles,
        paddingTop: '0',
        paddingBottom: '0'
    })
};


class NavBarWithRoles extends Component {
    render() {
        if (this.props.hidden || _.isNil(this.props.currentSubRole) || _.isNil(this.props.role) || this.props.role !== ROLES.EMPLOYEE || this.props.currentSubRole === NO_SUB_ROLES) {
            return null;
        }
        if (this.props.loading) {
            return (
                <Navbar color="light" light className="navbar-expand-custom">
                    <NavbarToggler id="sub-roles-navbar-toggler" className="sub-roles-navbar-toggler" />
                    <UncontrolledCollapse className="sub-roles-collapse" navbar toggler="#sub-roles-navbar-toggler">
                        <Nav>
                            <ConsentRequestsFilter/>
                        </Nav>
                        <Nav className="ml-auto">
                            <div className="loading-nav-bar-container">
                                <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                            </div>
                        </Nav>
                    </UncontrolledCollapse>
                </Navbar>
            )
        }
        return (
            <Navbar color="light" light className="navbar-expand-custom">
                <NavbarToggler id="sub-roles-navbar-toggler" className="sub-roles-navbar-toggler" />
                <UncontrolledCollapse className="sub-roles-collapse" navbar toggler="#sub-roles-navbar-toggler">
                    <Nav>
                        <ConsentRequestsFilter/>
                    </Nav>
                    {this.getBalanceLabel()}
                    <Nav className={this.props.currentSubRole !== SUB_ROLES.ANCHOR ? "ml-auto" : ""}>
                        <div className="sub-roles-container">
                            <h6>{_.get(this.props.translation, 'main.current_sub_role_label') + ':'}</h6>
                            <div title={this.getSubRoleSelectedOption().label || ""}>
                                <Select
                                    styles={customStyles}
                                    options={this.getSubRolesOptions()}
                                    value={this.getSubRoleSelectedOption()}
                                    onChange={this.handleChangeSubRole}
                                    components={this.getComponents()}
                                    isSearchable={false}/>
                            </div>
                        </div>
                    </Nav>
                    {this.props.currentSubRole === SUB_ROLES.ANCHOR || _.isNil(this.props.currentGroup) ? null :
                        <Nav>
                            <div className="groups-container">
                                <h6>
                                    {this.props.currentSubRole === SUB_ROLES.INSERTER || this.props.currentSubRole === SUB_ROLES.VALIDATOR ?
                                        _.get(this.props.translation, 'main.current_group_label') + ':' :
                                        _.get(this.props.translation, sharedLabelsPath.department_label) + ':'
                                    }
                                </h6>
                                <div title={this.getGroupSelectedOption().label || ""}>
                                    <Select
                                        styles={customStyles}
                                        options={this.getGroupsOptions()}
                                        value={this.getGroupSelectedOption()}
                                        onChange={this.handleChangeGroup}
                                        components={this.getComponents()}
                                        isSearchable={false}/>
                                </div>
                            </div>
                        </Nav>
                    }
                </UncontrolledCollapse>
            </Navbar>
        );
    }

    getBalanceLabel = () => {
        if (this.props.currentSubRole === SUB_ROLES.ANCHOR && !_.isNil(this.props.balance)) {
            return (
                <Nav className="ml-auto nav-bar-balance-label">
                    <h6>{_.get(this.props.translation, 'finance.balance_label') + ": " + this.props.balance.amount + CURRENCIES[this.props.balance.currency]}</h6>
                </Nav>
            )
        }
    };
    
    getSubRolesOptions = () => {
        return _.map(this.props.subRoles, role => ({value: role, label:_.get(this.props.translation, 'roles.' + SUB_ROLES_TRANSLATIONS[role])}));
    };


    getSubRoleSelectedOption = () => {
        let selectedElem = _.find(this.props.subRoles, role => role === this.props.currentSubRole);
        if (_.isNil(selectedElem)) {
            return null;
        }
        return {value: selectedElem, label: _.get(this.props.translation, 'roles.' + SUB_ROLES_TRANSLATIONS[selectedElem])};
    };

    getGroupsOptions = () => {
        return _.map(this.props.groups, elem => ({value: elem.id, label: elem.name, title: elem.name}));
    };

    getComponents = _ => ({
        Option: (props) => {
            return (
                <div title={props.data.title}>
                    <components.Option {...props}/>
                </div>
            );
        }
    });

    getGroupSelectedOption = () => {
        let selectedElem = _.find(this.props.groups, elem => elem.id === this.props.currentGroup);
        if (_.isNil(selectedElem)) {
            return null;
        }
        return {value: selectedElem.id, label: selectedElem.name};
    };

    handleChangeSubRole = (selectedOption) => {
        this.props.onChangeCurrentSubRole(selectedOption.value);
    };

    handleChangeGroup = (selectedOption) => {
        this.props.onChangeCurrentGroup(selectedOption.value);
    };
}

NavBarWithRoles.propTypes = {
    hidden: PropTypes.bool,
    loading: PropTypes.bool,
    role: PropTypes.string,
    currentSubRole: PropTypes.string,
    subRoles: PropTypes.array,
    currentGroup: PropTypes.string,
    groups: PropTypes.array,
    balance: PropTypes.object,
    translation: PropTypes.object.isRequired,
    onChangeCurrentSubRole: PropTypes.func.isRequired,
    onChangeCurrentGroup: PropTypes.func.isRequired
};

export default NavBarWithRoles;



// WEBPACK FOOTER //
// ./src/components/navBarWithRoles/NavBarWithRoles.js